<template>
  <div>
    <div v-if="successMessage" class="alert alert-success" role="alert">
      {{ successMessage }}
    </div>
    <form @submit.prevent>
      <div class="row">
        <div class="col-12">
          <fg-input type="text"
            placeholder="Full Name"
            :class="{ 'form-group--error': $v.fullName.$error }"
            v-model="$v.fullName.$model">
          </fg-input>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <fg-input type="email"
            placeholder="Email"
            :class="{ 'form-group--error': $v.email.$error }"
            v-model="$v.email.$model">
          </fg-input>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <select-role :validator="$v.selectedRole" />
        </div>
      </div>
      <div class="text-left">
        <p-button type="info"
          :loading="isCreatingUser"
          @click.native.prevent="createUser">
          Create
        </p-button>
      </div>
      <div class="clearfix"></div>
    </form>
  </div>
</template>

<script>
import SelectRole from '../Inputs/SelectRole.vue';
import { notify } from '../../services/notify';
import { required, email } from 'vuelidate/lib/validators';

export default {
  name: 'NewUserForm',
  components: {
    SelectRole
  },
  props: {
    group: Object
  },
  data() {
    return {
      fullName: "",
      email: "",
      selectedRole: "",
      isCreatingUser: false,
      successMessage: ""
    }
  },
  validations: {
    fullName: { required },
    email: { required, email },
    selectedRole: { required }
  },
  methods: {
    async createUser() {
      this.successMessage = "";

      this.$v.$touch();
      if (this.$v.$invalid) {
        notify().error('Please provide a name, email and role for the new user.')
        return;
      }

      this.isCreatingUser = true;
      const success = await this.$store.dispatch('user/createUser', {
        full_name: this.fullName,
        email: this.email,
        group_id: this.group.id,
        role_id: this.selectedRole.id,
        is_active: true
      });
      this.isCreatingUser = false;

      if (success) {
        this.successMessage = `Success! Created new user ${this.fullName}.`;
        this.$emit('hasUpdate');
        this.resetForm();
      }
    },
    resetForm() {
      this.fullName = "";
      this.email = "";
      this.selectedRole = "";
      this.$v.$reset();
    }
  }
};
</script>
